var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"news"},[_c('div',{staticClass:"wrapper"},[_c('div',{staticClass:"news_content __item"},[_c('h1',{staticClass:"news_title __left"},[_vm._v(" "+_vm._s(_vm.news.title)+" ")]),_c('p',[_vm._v(" "+_vm._s(_vm.getTime(_vm.news.pub_date))+" ")]),_c('div',{domProps:{"innerHTML":_vm._s(_vm.news.content)}})]),_c('br')])])
}
var staticRenderFns = []

export { render, staticRenderFns }